import {Inject, Injectable} from "@angular/core";
import {CHROME_EXTENSION_ID} from "../browser.communication.module";
import {LogCat, LogManager} from "../../../common/log";

declare var chrome;

// this service currently provides chrome only functionality.
// in the future we probably want to extend it to a more generic solution
@Injectable()
export class ChromeExtensionProxy{
	constructor(@Inject(CHROME_EXTENSION_ID) private chromeExtensionID){
	}
	public closeTab(){
		this.sendMessage('closeMe');
	}
	public focusTab(){
		this.sendMessage('focusMe');
	}

	private sendMessage(messgage:string){
		if (chrome) {
			if (!chrome.runtime){
				LogManager.warn(LogCat.Comm.browser, "running in chrome but no runtime support");
			}else {
				LogManager.debug(LogCat.Comm.browser, "chrome extension "+this.chromeExtensionID);
				chrome.runtime.sendMessage(this.chromeExtensionID, {message:messgage}, null,
					function (response) {
						if (response) {
							LogManager.debug(LogCat.Comm.browser, "back from send messge for " + messgage, response);
						}else{
							LogManager.warn(LogCat.Comm.browser, "back from extension with last error " + chrome.runtime.lastError);
						}
					});
			}
		}else{
			LogManager.info(LogCat.Comm.browser, "will not send message - chrome engine not detected. " + messgage);
		}
	}
}
